import { FlyerLayoutAbstract } from './flyer-layout.abstract'
import moment from 'moment-timezone'

export default class Flyer_layout_bottom_dashed_line_017LayoutModel extends FlyerLayoutAbstract {
  flourishes = [
    {
      name: 'dashed_line',
      left: 0,
      top: 422,
      width: 320,
      height: 1
    }
  ]

  textLayouts = {
    event_name_1: {
      top: 370,
      size: 34,
      height: 50,
      width: 300,
      right: 10,
      align: 'right',
      verticalAlign: 'bottom'
    },
    location_1: {
      top: 428,
      size: 15,
      left: 80,
      right: 10,
      width: 230,
      height: 17.5,
      align: 'right',
      widthAlign: 'right'
    },
    location_2: {
      top: 445.5,
      size: 15,
      left: 80,
      right: 10,
      width: 230,
      height: 17.5,
      align: 'right',
      widthAlign: 'right',
      whiteSpace: 'pre',
      nowrap: true
    }
  }

  dateLayouts = {
    date_1: {
      top: 428,
      daySize: 15,
      left: 5,
      width: 75,
      height: 17.5,
      widthAlign: 'left',
      lineHeight: 17.5,
      whiteSpace: 'pre'
    },
    date_2: {
      daySize: 15,
      top: 445.5,
      left: 5,
      width: 75,
      height: 38,
      widthAlign: 'left',
      lineHeight: 17.5,
      whiteSpace: 'pre'
    }
  }

  constructor(flyerDesign, eventData) {
    super(flyerDesign, eventData)
    this.init()
  }

  getLocationText2() {
    if (this.getDefaultText2()) {
      return `${this.getDefaultText2()}`
    }

    if (this.getDefaultText3()) {
      return `${this.getDefaultText3()}`
    }

    return null
  }
  getDayOfWeek(date, timeZone) {
    return date ? moment.tz(date, timeZone).format('ddd').toUpperCase() : ''
  }
  formatTime(date, timeZone) {
    return date ? moment.tz(date, timeZone).format('h:mma').toUpperCase() : ''
  }

  getDateTexts() {
    const startDate = this.eventData.starts_at
    const endDate = this.eventData.ends_at
    const timeZone = this.eventData.timezone || 'UTC'

    const date1 = this.dateLayouts.date_1
    const date2 = this.dateLayouts.date_2

    const date1Props = this.dateProps.date1Props
    const date2Props = this.dateProps.date2Props
    const stripZerosForHour = str => str ? str.replace(/^0/, '') : ''

    if (!startDate) {
      return { type: 'date', dates: [] }
    }

    let startTime = moment.tz(startDate, timeZone).format('h:mma').toUpperCase()
    let endTime = endDate ? moment.tz(endDate, timeZone).format('h:mma').toUpperCase() : ''
    startTime = stripZerosForHour(startTime)
    endTime = stripZerosForHour(endTime)

    let startDateStr = moment.tz(startDate, timeZone).format('MMM D').toUpperCase()

    let date1Text = ''
    let date2Text = ''

    if (endDate) {
      const isSingleDay = moment(startDate).isSame(endDate, 'day')
      if (isSingleDay) {
        date1Text = startDateStr
        date2Text = `${startTime}-${endTime}`.toUpperCase()
      } else {
        startTime = moment.tz(startDate, timeZone).format('MMM DD, h:mma').toUpperCase()
        endTime = moment.tz(endDate, timeZone).format('MMM DD, h:mma').toUpperCase()
        startTime = stripZerosForHour(startTime)
        endTime = stripZerosForHour(endTime)
        date1Text = startTime
        date2Text = `TILL\n${endTime}`.toUpperCase()
      }
    } else {
      date1Text = startDateStr
      date2Text = startTime
    }

    return {
      type: 'date',
      dates: [
        {
          text: date1Text,
          width: date1.width,
          top: date1.top,
          height: date1.height,
          left: date1.left,
          color: date1Props?.color?.replace('0x', '#') || '#000',
          font: date1Props?.font?.replace(/\s+/g, '-') || 'Arial',
          size: date1.daySize,
          widthAlign: date1.widthAlign,
          lineHeight: date1.lineHeight,
          whiteSpace: date1.whiteSpace || 'pre'
        },
        {
          text: date2Text,
          width: date2.width,
          top: date2.top,
          height: date2.height,
          left: date2.left,
          color: date2Props?.color?.replace('0x', '#') || '#000',
          font: date2Props?.font?.replace(/\s+/g, '-') || 'Arial',
          size: date2.daySize,
          widthAlign: date2.widthAlign,
          lineHeight: date2.lineHeight,
          whiteSpace: date1.whiteSpace || 'pre'
        }
      ]
    }
  }
}
